import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DocumentTitle from 'react-document-title';
import { HeaderSmall, Greeting } from '../common/layout/HeaderSmall';
import Spinner from '../common/Spinner';
import { loadTitle } from '../../util/helperFuncs';

const MLS_PAGE_TITLE = 'MLS Listings';

const MLSListings = ({ profile: { profile, loading } }) => {
  if (!profile || loading) {
    return (
      <div className="mls-listings">
        <div className="container">
          <div className="row spinner">
            <div className="col">
              <Spinner />
            </div>
          </div>
        </div>
      </div>
    );
  }

  const { page_title, info: { home_listing_url } } = profile;

  return (
    <div className="mls-listings">
      <DocumentTitle title={loadTitle(page_title, MLS_PAGE_TITLE, MLS_PAGE_TITLE)}>
        <div>
          <HeaderSmall profile={profile}>
            <Greeting title={MLS_PAGE_TITLE} subheading="" />
          </HeaderSmall>
          <main role="main" className="container">
            <p>
              <iframe
                style={{ border: '0px #ffffff none' }}
                src={home_listing_url}
                name="myiFrame"
                width="100%"
                height="750px"
                frameBorder="0"
                marginWidth="0px"
                marginHeight="0px"
                scrolling="yes"
                allowFullScreen
                title="MLS Listings"
              />
            </p>
          </main>
        </div>
      </DocumentTitle>
    </div>
  );
};

MLSListings.propTypes = {
  profile: PropTypes.shape({
    profile: PropTypes.object,
    loading: PropTypes.bool,
  }).isRequired,
};

const mapStateToProps = state => ({
  profile: state.profile,
});

export default connect(mapStateToProps)(MLSListings);
export { MLS_PAGE_TITLE };
